import './src/main.css'
import BorderBox5 from './src/main.vue'

export default function (Vue) {
  Vue.component(BorderBox5.name, BorderBox5)
}



// WEBPACK FOOTER //
// ./~/@jiaminghi/data-view/lib/components/borderBox5/index.js